// const colors = [
//   'rgb(153, 153, 153)',
//   'rgba(223, 1, 1)',
//   'rgba(4, 35, 51)',
//   'rgba(0, 64, 255)',
//   'rgba(4, 180, 49)',
//   'rgba(215, 223, 1)',
//   'rgba(138, 8, 104)',
// ];

export const opcoes = {
  // color: colors,
  title: {
    text: ''
  },
  tooltip: {
    trigger: 'axis'
  },
  legend: {
    data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  toolbox: {
    feature: {
      saveAsImage: {},
      // dataZoom: {
      //   yAxisIndex: false
      // },
      // brush: {
      //   type: ['lineX', 'clear']
      // }
    },
  },
  // brush: {
  //   xAxisIndex: 'all',
  //   brushLink: 'all',
  //   outOfBrush: {
  //     colorAlpha: 0.1
  //   }
  // },
  xAxis: {
    type: 'category',
    axisTick: {
      alignWithLabel: true
    },
    axisLine: {
      onZero: false,
    },
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  },
  yAxis: {
    type: 'value'
  },
  series: [
    {
      name: 'Email',
      type: 'line',
      stack: 'Total',
      data: [120, 132, 101, 134, 90, 230, 210]
    },
    {
      name: 'Union Ads',
      type: 'line',
      stack: 'Total',
      data: [220, 182, 191, 234, 290, 330, 310]
    },
    {
      name: 'Video Ads',
      type: 'line',
      stack: 'Total',
      data: [150, 232, 201, 154, 190, 330, 410]
    },
    {
      name: 'Direct',
      type: 'line',
      stack: 'Total',
      data: [320, 332, 301, 334, 390, 330, 320]
    },
    {
      name: 'Search Engine',
      type: 'line',
      stack: 'Total',
      data: [820, 932, 901, 934, 1290, 1330, 1320]
    }
  ]
};
